import React, { Component } from 'react';
import { isEmpty } from "lodash";
import { CardLayout, TableLayout } from '../containers/Layout';
import { TableRow, TableCell, Button, Box, Grid, Card, TableBody, TableHead, List, ListItem, Typography, Collapse, Accordion, AccordionSummary, AccordionDetails, ListItemText, IconButton, Divider, ListItemIcon } from '@material-ui/core';
import SwipeableTabs from '../../../../commonModules/MUI/SwipeableTabs';
import Currency from '../../../../commonModules/Currency';
import { StrippedTable } from '../../../../commonModules/MUI/StrippedTable';
import { ChevronRightRounded, CloudDownloadRounded, DescriptionRounded, ExpandLess, ExpandMore, ExpandMoreRounded, MemoryRounded } from '@material-ui/icons';
import StockExtractButton from '../StockExtractButton';
import PopUp from '../../../../commonModules/interface/PopUp';
import Photos from '../../../../commonModules/interface/input-files';
import GridList from './GridList';
import { toast } from 'react-toastify';
import { createSubProduct, fetchSubProductsFromMainProduct } from '../../../../../../../jsx/actions/recyclingAction'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ProductCompo from './SubProducts/ProductCompo';
import SingleSubProduct from './SubProducts/SingleSubProduct';
import ProductStockList from './SubProducts/ProductStockList';

class SingleProduct extends Component {
    state = {
        stock: [],
        AVAILABLE: [],
        PAYG: [],
        OUT: [],
        RESERVATION: [],
        OCCASION: [],
        INSTALLATION: [],
        stock_type: {value: "AVAILABLE", label: "Disponible"},
        // stock: ["", false],
        mainPhoto: 0,
        photos:[],
        URIs: [],
        updatePhotos: false,
        openGrid: false,
        SUB_PRODUCTS:[] ,
        open_desc: true,
        open_compo: false,
        openSubDetails: {}
    }
    componentDidMount = async () => {
        console.log("[INFO] MOUNTING PRODUCT SINGLE ");

        this.findStocks(this.props.product.id)
        this.findSales(this.props.product.product_ref, "OCCASION")
        this.findSales(this.props.product.id, "PAYG")
        this.findSales(this.props.product.id, "OUT")
        this.findSales(this.props.product.id, "RESERVATION")
        this.findSales(this.props.product.id, "INSTALLATION")
        let SUB_PRODUCTS = await this.props.fetchSubProductsFromMainProduct(this.props.product.id)
        console.log('=================SUBS LIST===================');
        console.log({SUB_PRODUCTS});
        console.log('====================================');
        this.setState({
            SUB_PRODUCTS
        })
        // this.getPhotos()
    }
    findStocks = (prodId) => {
        const { AVAILABLE, SHOPS } = this.props
        if(AVAILABLE){
            const res = Object.values(AVAILABLE).filter(
                stock => stock.product_id === prodId && stock.quantity > 0).map( 
                    stock => ( 
                    <TableRow key={stock.id} hover>
                        <TableCell>{SHOPS[stock.shop_id].name}</TableCell>
                        {/* <TableCell>{SHOPS[stock.shop_id].city}</TableCell> */}
                        <TableCell>{stock.quantity}</TableCell>
                    </TableRow>
                )
            )
            console.log("[INFO] res findStocks",res);
            this.setState({
                stock: res,
                AVAILABLE: res
            })
        }
    }
    findSales = (prodId, status) => {
        const { SHOPS, STOCKS } = this.props
        if(STOCKS[status]){
            const res = Object.values(STOCKS[status]).filter(
                stock => stock.product_id === prodId && stock.quantity > 0).map( 
                    stock => ( 
                    <TableRow key={stock.id} hover>
                        <TableCell>{SHOPS[stock.shop_id].name}</TableCell>
                        {/* <TableCell>{SHOPS[stock.shop_id].city}</TableCell> */}
                        <TableCell>{stock.quantity}</TableCell>
                    </TableRow>
                )
            )
            console.log("[INFO] res findStocks",res);
            this.setState({
                [status]: res
            })
        }
    }

    displayFields(){
        console.log("[INFO] displayFields");

        const prod = this.props.product
        const match = {
            "Garantie (Années)":prod.garantie,
            // "Marque":prod.marque,
            // "Nom":prod.name,
            "Type":prod.product_type,
            // "Prix HT":prod.prix_venteHT,
            // "Prix TTC":prod.prix_venteTTC,
            // "Référence":prod.ref,
            // " ":prod.photos,
            "Poids (Kg)":prod.poids,   
            "Largeur (mm)":prod.largeur,   
            "Longueur (mm)":prod.longueur,   
            "Hauteur (mm)":prod.hauteur, 

            "ID Fournisseur": prod.id_supplier,
            "HS Code": prod.hs_code,

            "Auto décharge": prod.bat_auto_decharge,
            "Capacité_Max(Ah)":prod.bat_max_capacity,
            "Type de batterie" :prod.bat_type,
            "Tension (V)":prod.bat_tension,
            "Nb cycles":prod.bat_nb_cycles,
            "Nb cycles à  30% de DOD":prod.bat_nb_cycles30,
            "Nb cycles à  50% de DOD":prod.bat_nb_cycles50,
            "Nb cycles à  80% de DOD":prod.bat_nb_cycles80,
            "Rendement énergétique (%)":prod.bat_rendement,            
            "Température d'exploitation":prod.bat_temperature,
            "Puissance (W) ":prod.pan_puissance,            
            "Cellules":prod.pan_cell,
            "Tension(Voc)" :prod.pan_tension,
            "Courant(Ioc)":prod.pan_courant,
            "Tension(Voc)" :prod.pan_tensionVoc,
            "Courant(Ioc)":prod.pan_courantIoc,
            "Tension(Vmpp)" :prod.pan_tensionVmpp,
            "Courant(Impp)":prod.pan_courantImpp,
            "Hauteur(mm)":prod.pan_height,
            "Largeur(mm)":prod.pan_width,
            "Profondeur(mm)":prod.pan_profondeur,
            "Rendement(%)":prod.pan_rendement,
            "Nombre de Conducteurs ":prod.cab_nb_conducteurs,
            "Section des conducteurs":prod.cab_section,
            "Type de conduits":prod.cab_type,
            "Tension de charge 'absorption'":prod.conv_absorption,
            "Courant de de charge de batterie de service (A)":prod.conv_courant_service,
            "Courant de de charge de batterie de démarrage (A)":prod.conv_courant_start,
            "Efficacité maximale":prod.conv_eff_max,
            "Tension de charge 'float' (VCC)":prod.conv_float,
            "Puissance de sortie (VA) ":prod.conv_puissance,
            "Puissance à 25°C (W) ":prod.conv_puissance25,
            "Puissance à 40°C (W) ":prod.conv_puissance40,
            "Puissance à 65°C (W)":prod.conv_puissance65,
            "Puissance crête":prod.conv_puissance_crete,
            "Type de signal":prod.conv_signal,
            "Puissance de sortie continue à 25°C (W)":prod.conv_sortie25,
            "Puissance de sortie continue à 40°C (W)":prod.conv_sortie40,
            "Tension entrée":prod.conv_tension,
            "Plage de tension d'entrée (VDC) max":prod.conv_tension_max,
            "Plage de tension d'entrée (VDC) min":prod.conv_tension_min,
            "Tension sortie nominale":prod.conv_tension_sortie,
            "Courant de Sortie Max":prod.conv_MPPT_courant_sortie,
            "Tension PV Max":prod.conv_MPPT_tensionPV_max,
            "Puissance PV Max":prod.conv_MPPT_puissancePV_max,
            
            "Tension d'entrée maximale (V)":prod.ond_tension_max,
            "Courant d'entrée maximal (A)":prod.ond_courant_entree,
            "Nombre de MPPT":prod.ond_nb_mppt,
            "Puissance active CA (W)":prod.ond_puissance_active,
            "Puissance apparente maximale (VA)":prod.ond_puissance_apparente,
            "Courant de Sortie Max (A)":prod.ond_courant_sortie,
            "Efficacité maximale (%)":prod.ond_eff_max,
            "Fréquence nominale du réseau (Hz)":prod.ond_freq,

            "Fonctionnement en triphasé":prod.conv_triphase,
            "Flux Lumineux (lm)":prod.lam_flux,
            "Puissance(W)":prod.lam_puissance,
            "Puissance(W)":prod.pomp_puissance,
            "Tension d'alimentation":prod.lam_tension,
            "Affichage":prod.reg_affichage,
            "Courant de charge nominal (V)":prod.reg_courant,
            "Puissance nominale PV 12V ":prod.reg_puissance_pv12,
            "Puissance nominale PV 24V ":prod.reg_puissance_pv24,
            "Puissance nominale PV 48V ":prod.reg_puissance_pv48,
            "Tension PV maximale en circuit ouvert":prod.reg_tension_max,
            "Type de Régulateur":prod.reg_type,
            "Type Equipement":prod.men_type,
            "Puissance à vide (W)":prod.tv_puissance_vide,
            "Puissance en Fonctionnement":prod.tv_puissance_fonc,
            "Taille (pouces)":prod.tv_taille,
            "Puissance(W)":prod.vent_puissance,
            "Autres":prod.men_infos,            
            "Description":prod.desc,            
        }
        
        return Object.keys(match).map((field, i) => {            
            if(match[field]){

                let data = match[field]
                if(Array.isArray(data)){
                    data.sort( (a, b) => {
                        return a - b;
                    })
                    data = data.join(' / ')
                }
                return(  
                    <StrippedTable key={field+i}>
                        <TableCell>{field} :</TableCell>
                        <TableCell>{data}</TableCell>
                    </StrippedTable>
                )
            }
        })
    }
    handleSubmitPhotos = async () => {
        let data = {
            photos: this.state.photos,
            id: this.props.product.id
        }
        await this.props.updatePhotosProduct(data)
        if(this.props.STATE.products.error){
            console.log("ERROR", this.props.STATE.products.error);
            
            toast.error(  this.props.STATE.products.error)
        } else{
            console.log("fetched");
            
            toast.info( "Le produit a été modifié avec succès")
            this.setState({
                photos: this.props.product.photos,
                updatePhotos: false
            })
        }
    }
    // handleSubmitPhotosAdd = async () => {
    //     let data = {
    //         photos: this.props.photos.concat(this.state.photos),
    //         id: this.props.product.id
    //     }
    //     await this.props.updatePhotosProduct(data)
    //     if(this.props.STATE.products.error){
    //         console.log("ERROR", this.props.STATE.products.error);
            
    //         this.props.notif( "danger", this.props.STATE.products.error)
    //     } else{
    //         console.log("fetched");
            
    //         this.props.notif( "info", "Le produit a été modifié avec succès")
    //         this.setState({
    //             photos: this.props.product.photos,
    //             updatePhotos: false
    //         })
    //     }
    // }
    render(){
        console.log("[STATE] PRODUCT",this.props, this.state)
        const { product } = this.props;
        const { updatePhotos, openGrid, openSubDetails } = this.state;
        const stockTypeList = [
            {value: "AVAILABLE", label: "Disponible"},
            {value: "PAYG", label: "Pay as you Go"},
            {value: "OUT", label: "Vente directes"},
            {value: "RESERVATION", label: "Réservé"},
            {value: "OCCASION", label: "Occasion"},
            {value: "INSTALLATION", label: "Installation"},
        ]
        return(
            <Box>
                {updatePhotos &&
                    <PopUp
                        close={()=> this.setState({ updatePhotos: false })}
                        submitAction={this.handleSubmitPhotos}
                        maxWidth="sm"
                        title="Modifier photos"
                        disabledSubmit={this.props.STATE.products.fetching}
                    >
                        <Box p={1}>
                            <Photos photoList={(photos) => this.setState({ photos})} photos={this.state.photos === null ? [] : this.state.photos } />
                        </Box>
                    </PopUp>
                }
                {/* {addPhotos &&
                    <PopUp
                        close={()=> this.setState({ addPhotos: false })}
                        submitAction={this.handleSubmitPhotosAdd}
                        maxWidth="sm"
                        title="Modifier photos"
                        disabledSubmit={this.props.STATE.products.fetching}
                    >
                        <Box p={1}>
                            <Photos photoList={(photos) => this.setState({ photos})} photos={this.state.photos === null ? [] : this.state.photos } />
                        </Box>
                    </PopUp>
                } */}
                {openGrid &&
                    <GridList
                        {...product}
                        handleClose={() => this.setState({ openGrid: false })}
                    />
                }
                {!isEmpty(openSubDetails) &&
                    <SingleSubProduct
                        product={openSubDetails}
                        closePopup={() => this.setState({ openSubDetails: {} })}
                    />
                }
                <Box>
                    <Box p={1} style={{textAlign: "right"}}>
                        <Button color="primary" variant="contained" onClick={() => this.setState({updatePhotos: true})}>Modifier Photos</Button>
                    </Box>   
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={5}>
                            {product.photos && product.photos.length > 0 && product.photos[0].filename &&
                                <Box p={1}>
                                    <div className="thumbnail" style={{ textAlign: "center"}} >
                                        <img id="mainPhoto" style={{ maxHeight: "400px"}}  src={`/stocks/photos/${product.photos[0].filename}`} alt=""/>
                                    </div>
                                    {/* <div className="thumbnail" style={{ textAlign: "center"}} >
                                        <img id="mainPhoto" style={{ maxHeight: "400px"}}  src={product.src[this.state.mainPhoto]} alt=""/>
                                    </div> */}
                                    {/* <Grid container spacing={2}>
                                        {this.photoList()}
                                    </Grid> */}
                                </Box>
                            }
                            {!product.photos &&
                                <Box p={1}>
                                    <div className="thumbnail">
                                        <img src="img/noImg.png" alt=""/>
                                    </div>
                                </Box>
                            }
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Box p={1}>
                                <Typography variant="h5" gutterBottom>{product.name}</Typography>
                                {/* <Box>
                                    <Typography variant="h5" color="secondary"><Currency value={product.prix_venteTTC} /></Typography>
                                </Box>
                                <Typography variant="body1">Marque: <b>{product.marque}</b></Typography>
                                <Box>
                                    <Typography variant="subtitle">Référence: <b>{product.ref}</b></Typography>
                                </Box> */}
                                <Typography variant="body1" color="textSecondary" component="p">
                                    Référence: <b>{product.ref}</b>
                                </Typography>
                                {product.id_supplier && (
                                    <Typography variant="body1" color="textSecondary" component="p">
                                        Réf. fournisseur: <b>{product.id_supplier}</b>
                                    </Typography>
                                )}
                                <Typography variant="body1" color="textSecondary" component="p">
                                    Marque: <b>{product.marque}</b>
                                </Typography>
                                <Typography variant="h6" color="secondary" component="p">
                                    <b>Prix TTC: <Currency value={product.prix_venteTTC} /></b>
                                </Typography>
                                <Typography variant="body1" color="textSecondary" component="p">
                                    {product.desc}
                                </Typography>
                            </Box>
                            {/* <Box p={1}>
                            </Box>    */}
                            <Box style={{display: 'flex'}}>
                                <Button
                                    onClick={() => this.setState({ openGrid: true })}
                                    color="primary"
                                >
                                    Afficher les prix
                                </Button>
                                <StockExtractButton
                                    icon={<CloudDownloadRounded />}
                                    color="primary"
                                    title="Télécharger les prix"
                                    extract="price-details-single"
                                    product_id={product.id}
                                />
                            </Box>
                            {/* <Card>
                                <TableLayout>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>
                                                <h4>Prix TTC: </h4>
                                            </TableCell>
                                            <TableCell>
                                                <h4>{new Intl.NumberFormat("fr").format(product.prix_venteTTC)} FCFA </h4>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Référence: </TableCell>
                                            <TableCell>{product.ref}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Type: </TableCell>
                                            <TableCell>{product.product_type}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Marque: </TableCell>
                                            <TableCell>{product.marque}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </TableLayout>
                            </Card> */}
                        </Grid>
                    </Grid>
                </Box>

                <Divider/>
                <Box p={1}>
                    <Card>
                        <Box p={1}>
                            <SwipeableTabs
                                // default={this.props.occasion ? "Occasion" : "Description"}
                                labels={["Infos Produit", "Stocks"]}
                                default={"Infos Produit"}
                                color={"secondary"}
                            >
                                <Box>
                                    <ListItem
                                        // style={{backgroundColor: "lavender"}}
                                    >
                                        <ListItemIcon>
                                            <DescriptionRounded />
                                        </ListItemIcon>
                                        <ListItemText primary={"Description"} />
                                        <IconButton
                                            title="Caractéristiques du produit"
                                            onClick={ () => this.setState({
                                                open_desc: !this.state.open_desc
                                            }) } 
                                        >
                                            {this.state.open_desc ? <ExpandLess /> : <ExpandMore />}
                                        </IconButton>
                                    </ListItem>
                                    {this.state.open_desc &&
                                        <Collapse
                                            key={"desc"}
                                            in={true} 
                                            timeout="auto" 
                                            unmountOnExit
                                        >
                                            <Box p={4}>
                                                <TableLayout> 
                                                    <TableBody>
                                                        {this.displayFields()}
                                                    </TableBody>
                                                </TableLayout>
                                            </Box>
                                        </Collapse>
                                    }
                                    <Box p={1}>
                                        <Divider />
                                    </Box>
                                    <ListItem
                                        // style={{backgroundColor: "lavender"}}
                                    >
                                        <ListItemIcon>
                                            <MemoryRounded />
                                        </ListItemIcon>
                                        <ListItemText primary={"Composition"} />
                                        <IconButton
                                            title="Composition du produit"
                                            onClick={ () => this.setState({
                                                open_compo: !this.state.open_compo
                                            }) } 
                                        >
                                            {this.state.open_compo ? <ExpandLess /> : <ExpandMore />}
                                        </IconButton>
                                    </ListItem>
                                    {this.state.open_compo &&
                                        <Collapse
                                            key={"compo"}
                                            in={true} 
                                            timeout="auto" 
                                            unmountOnExit
                                        >
                                            <Box p={4}>
                                                <ProductCompo
                                                    list={this.state.SUB_PRODUCTS}
                                                    subDetails={(prod) => this.setState({ openSubDetails: prod})}
                                                />
                                            </Box>
                                        </Collapse>
                                    }
                                </Box>                                
                                <Box p={2}>
                                    <ProductStockList
                                        {...this.state}
                                    />
                                </Box>
                            </SwipeableTabs>
                        </Box>
                    </Card>
                </Box>
            </Box>
        )
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchSubProductsFromMainProduct
    }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(SingleProduct);